import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppData } from '../../../../models/appdata';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbAddNewPatient } from '../../provider/dashboard/modal/addnewpatient.modal';
import { NgbAddBill } from '../../opbilling/modal/addbill.modal';
import { NgbSearchPatientModal } from '../../follow up/counsellingregistry/modal/searchpatient.modal';
import { Router } from '@angular/router';
import { NgbAddbilladv } from '../../opbilling/modal/addbilladv.modal';
import { PatientInfoByFormattedCodeController } from '../../../../models/actor/actor';
import { NgbPatientBillsModal } from '../../follow up/counsellingregistry/modal/patientbills.modal';
import { NgbErpSetupModal } from '../../profile/patientprofileview/personaldetailview/modal/erpsetup.modal';



import { ThemeService, AppTheme } from '../../../../services/theme.service';

@Component({
  selector: 'nurseapp-navbar',
  templateUrl: './nursenavbar.component.html',
  styleUrls: ['./nursenavbar.component.scss']
})

export class NurseNavbarComponent {
  public TestVersion: Boolean = false;
  currentLang = 'en';
  toggleClass = 'ft-maximize';
  public NavActorImageFile: string;
  public DispalyName: string;
  public BranchName: string;
  public RoleName: string;
  public IsAdmin: boolean = false;
  public display: boolean = false;
  public displaybar: boolean = true;
  public displayclose: boolean = false;
  constructor(
    public translate: TranslateService,
    private modalService: NgbModal,
    private router: Router,
    public themeService: ThemeService
  ) {
    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : 'en');
  }

  get currentTheme(): string {
    return this.themeService.currentTheme;
  }

  get themes(): AppTheme[] {
    return this.themeService.themes;
  }

  selectTheme(themeId: string) {
    this.themeService.setTheme(themeId);
  }


  HasAccess(featureName: string): boolean {
    const appUserSettingInfo = AppData.Instance().AppUserSettingInfo;
    if (!appUserSettingInfo || !appUserSettingInfo.RoleFeatureLinkInfoController) {
      return true;
    }
    const roleName = AppData.Instance().SelectedRoleName;
    const f = appUserSettingInfo.RoleFeatureLinkInfoController.filter(function (v) {
      return v && v.FeatureName == featureName && roleName == v.RoleName;
    });
    return f != null && f.length > 0;
  }
  HasAccess2(featureName: string): boolean {
    return false;
  }
  SetIsAdmin() {
    switch (this.RoleName) {
      case 'Super Admin':
        this.IsAdmin = true;
        break;
      default:
        {
          this.IsAdmin = false;
        }
    }
  }
  public logo: string = "";
  public logowidth: number;
  public logoheight: number;
  ngOnInit() {
    const cas = AppData.Instance().cas || {} as any;
    this.logo = cas.Navlogo || "Navlogo.png";
    this.logowidth = cas.HlogoWidth || 150;
    this.logoheight = cas.HlogoHeight || 50;
    if (AppData.Instance().UserLoginDetails != null) {
      this.DispalyName = AppData.Instance().UserLoginDetails.DisplayName || 'admin';
      this.RoleName = AppData.Instance().SelectedRoleName || 'Super Admin';
      this.SetIsAdmin();
      this.NavActorImageFile = AppData.Instance().UserLoginDetails.ActorImageFile;
      this.BranchName = AppData.Instance().SelectedBranchName;
    }
    else {
      this.NavActorImageFile = null;
    }
  }

  ChangeLanguage(language: string) {
    this.translate.use(language);
  }

  ToggleClass() {
    if (this.toggleClass === 'ft-maximize') {
      this.toggleClass = 'ft-minimize';
    }
    else
      this.toggleClass = 'ft-maximize'
  }
  OpenModal() {
    const modalRef = this.modalService.open(NgbAddNewPatient,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
  }
  OpenModalErp() {
    const modalRef = this.modalService.open(NgbErpSetupModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
  }
  OpenBill() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((val: string) => {

      this.router.navigate(['healins/iohreceipt', { FormattedCodedata: val }]);

      // modalRef.componentInstance.FormattedCode = val;
      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetTreatmentCyclesController() })
    });
  }
  AddRefund() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.PATIENT_OBJ = true;
    modalRef.componentInstance.PATIENT_FORMATTED_CODE = false;
    modalRef.result.then((val: PatientInfoByFormattedCodeController) => {
      const modalRef = this.modalService.open(NgbPatientBillsModal,
        {
          centered: true,
          size: "lg",
          backdrop: 'static',
          keyboard: false
        })
      modalRef.componentInstance.ActorCode = val.ActorCode;
      modalRef.result.then((val2: number) => {
        this.router.navigate(['healins/refundreceipt', { FormattedCodedata: val.FormattedCode, ChargeEntryCode: val2 }]);
      });


    });
  }
  OpenBillAdv() {
    const modalRef = this.modalService.open(NgbAddbilladv,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Type = "FromMain"
  }
  openside() {
    this.display = true;
    this.displayclose = true;
    this.displaybar = false;
    // document.getElementById("mySidenav").style.width = "250px";
    //this.router.navigate(['healins/sidebar']);
    //document.getElementById("sidebar").classList.toggle('active');
  }
  closeside() {
    this.display = false;
    this.displayclose = false;
    this.displaybar = true;
  }
}
